<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> カウンセリング一覧 <span>(全 {{ filter.length }} 件)</span></span>
        </div>
        <div class="card-body d-none d-sm-block">
          <div class="form-group row">
            <div class="col-md-4">
              <label class="col-form-label" for="line_graph">グラフ表示</label>
              <select class="form-control" id="line_graph" name="line_graph" (change)="updateGraph($event)">
                <option value="">-- 選択してください --</option>
                @for (l of lineGraphOptions; track l.id) {
                  <option [value]="l.id">{{ l.name }}</option>
                }
              </select>
            </div>
          </div>
          @if (select.lineGraph) {
            <div class="canvas-container" style="height: 300px;">
              <canvas id="myChart"></canvas>
            </div>
          }
        </div>
        <div class="card-body">
          <ul class="pagination pull-right">
            @for (p of pagerCount; track p) {
              <li [class.active]="p === limitBegin / pageLimit">
                <a href="" class="pager-item" (click)="pagerClick(p); $event.preventDefault()">{{ p + 1 }}</a>
              </li>
            }
          </ul>
          @if (!searching && filter.length === 0) { <span>該当するデータはありません</span> }
          @if (showTable) {
            <table class="table table-bordered table-sm table-hover font-md-10px">
              @if (filter.length > 0) {
                <thead>
                  <tr>
                    <th>実施日</th>
                    <th>担当者</th>
                    <th>実施メニュー</th>
                    <th>詳細</th>
                  </tr>
                </thead>
              }
              <tbody>
                @for (item of pagedItems; track item.id) {
                  <tr>
                    <td>{{ formatDate(item.counseledAt) }}</td>
                    <td>{{ item.counselor }}</td>
                    <td>{{ item.trainingProgram?.name }}</td>
                    <td class="text-center">
                      <a class="mt-1 mb-1 btn btn-primary btn-sm text-white" [routerLink]="['/counsel', item.id]" title="詳細">
                        <i class="fa s-icon-fileChoice fa-fw"></i>
                      </a>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
          <ul class="pagination pull-right">
            @for (p of pagerCount; track p) {
              <li [class.active]="p === limitBegin / pageLimit">
                <a href="" class="pager-item" (click)="pagerClick(p); $event.preventDefault()">{{ p + 1 }}</a>
              </li>
            }
          </ul>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="d-none d-sm-block col-md-12 text-right">
              <button routerLink="/counsel/photo" class="btn bg-close text-white"><i class="fa s-icon-image"></i>&nbsp;ビフォーアフター</button>
            </div>
            <div class="d-block d-sm-none col-12">
              <button type="button" class="btn btn-success col-12 form-group" data-toggle="modal" data-target="#lineGraphModal"><i class="fa s-icon-marketing"></i>&nbsp;グラフ表示</button>
              <button routerLink="/counsel/photo" class="btn bg-close text-white col-12 form-group"><i class="fa s-icon-image"></i>&nbsp;ビフォーアフター</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="lineGraphModal" tabindex="-1" role="dialog" aria-labelledby="lineGraphModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="lineGraphModalLabel"><i class="fa s-icon-marketing"></i>&nbsp;推移グラフ</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group row">
            <div class="col-md-4">
              <label class="col-form-label" for="line_graph_modal">グラフ表示</label>
              <select class="form-control" id="line_graph_modal" name="line_graph" (change)="updateGraph($event)">
                <option value="">-- 選択してください --</option>
                @for (l of lineGraphOptions; track l.id) {
                  <option [value]="l.id">{{ l.name }}</option>
                }
              </select>
            </div>
          </div>
          @if (select.lineGraph) {
            <div class="canvas-container-modal" style="height: 300px;">
              <canvas id="myChartModal"></canvas>
            </div>
          }
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" data-dismiss="modal"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
        </div>
      </div>
    </div>
  </div>
</div>
